import { useEffect } from "react";
import { documentTitleWithBrand } from "../utils/document-title";

export function useDocumentTitle(segmentTitle: string): void {
  useEffect(function () {
    document.title = documentTitleWithBrand(segmentTitle);
  }, [segmentTitle]);
}
